// Protega customer-support contact details, shared by every page that links to WhatsApp.
const WHATSAPP_NUMBER = '919324095283';
export const WHATSAPP_NUMBER_DISPLAY = '+91 93240 95283';
/** General questions only — claims are filed on the dashboard or WhatsApp. */
export const SUPPORT_EMAIL = 'support@protega.ai';

/** wa.me link to Protega support with a pre-filled message. */
export const whatsappUrl = (message: string) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WHATSAPP_SUPPORT_URL = whatsappUrl('Hi, I want to raise a request');

/** "+919876543210" / "09876543210" / "9876543210" → "+91 98765 43210". */
export const formatIndianMobile = (phone?: string | null) => {
  const digits = (phone ?? '').replace(/\D/g, '').slice(-10);
  return digits.length === 10 ? `+91 ${digits.slice(0, 5)} ${digits.slice(5)}` : phone ?? '';
};
